// extracted by mini-css-extract-plugin
module.exports = {"root":"_4f720283bf--root--ybpHh","dimensions":"_4f720283bf--dimensions--BDjPJ"};